module.exports = __webpack_public_path__ + "static/media/empty.568908b5.png";